// Aviso destacado no topo do Portal: as atividades de quem está logado (responsável pelo nome do usuário) que estão
// atrasadas, são de hoje ou dos próximos 3 dias (Início › Gestão de atividades). Consulta no máximo a cada 10 min
// (sessionStorage) e pode ser escondido até o dia seguinte.
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { marketing, type MinhasAtividades } from '../lib/api/marketing';

const CACHE = 'minhas_atividades';
const OCULTO = 'minhas_atividades_oculto';
const hoje = () => new Date(Date.now() - 3 * 3600_000).toISOString().slice(0, 10);

export default function AvisoAtividades() {
  const [m, setM] = useState<MinhasAtividades | null>(null);
  const [oculto, setOculto] = useState(() => { try { return localStorage.getItem(OCULTO) === hoje(); } catch { return false; } });
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    if (oculto) return;
    try {
      const c = JSON.parse(sessionStorage.getItem(CACHE) ?? 'null') as { em: number; m: MinhasAtividades } | null;
      if (c && Date.now() - c.em < 10 * 60_000) { setM(c.m); return; }
    } catch { /* sem cache */ }
    marketing.minhas().then((r) => { setM(r); try { sessionStorage.setItem(CACHE, JSON.stringify({ em: Date.now(), m: r })); } catch { /* ok */ } }).catch(() => undefined);
  }, [oculto, pathname]);

  if (oculto || !m || m.hoje + m.proximos === 0 || pathname === '/atividades') return null;
  const urgente = m.hoje > 0 || m.atrasadas > 0;
  const partes = [m.atrasadas && `${m.atrasadas} atrasada${m.atrasadas > 1 ? 's' : ''}`, m.hoje - m.atrasadas > 0 && `${m.hoje - m.atrasadas} para hoje`, m.proximos && `${m.proximos} nos próximos dias`].filter(Boolean).join(' · ');
  return (
    <div role="status" style={{
      display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap', padding: '10px 16px', margin: '0 0 12px',
      background: urgente ? '#fef2f2' : '#fffbeb', border: `1px solid ${urgente ? '#fecaca' : '#fde68a'}`, borderLeft: `5px solid ${urgente ? '#dc2626' : '#f59e0b'}`, borderRadius: 10,
    }}>
      <span style={{ fontSize: 18 }} aria-hidden>🔔</span>
      <div style={{ flex: 1, minWidth: 220 }}>
        <b style={{ color: urgente ? '#991b1b' : '#92400e' }}>{m.nome.split(' ')[0]}, você tem atividades: {partes}.</b>
        <div style={{ fontSize: 12, color: '#475569', marginTop: 2 }}>
          {m.itens.slice(0, 4).map((x) => `${x.dia.slice(8, 10)}/${x.dia.slice(5, 7)} ${x.titulo}`).join(' · ')}{m.itens.length > 4 ? ` · +${m.itens.length - 4}` : ''}
        </div>
      </div>
      <button onClick={() => navigate(`/atividades?quem=${encoUri(m.nome)}`)} style={{ font: 'inherit', fontWeight: 700, border: 0, borderRadius: 8, padding: '7px 12px', background: urgente ? '#dc2626' : '#f59e0b', color: '#fff', cursor: 'pointer' }}>Ver minhas atividades</button>
      <button onClick={() => { setOculto(true); try { localStorage.setItem(OCULTO, hoje()); } catch { /* ok */ } }} aria-label="Esconder até amanhã" title="Esconder até amanhã"
        style={{ font: 'inherit', border: 0, background: 'none', color: '#64748b', cursor: 'pointer', fontSize: 16 }}>✕</button>
    </div>
  );
}
const encoUri = (s: string) => encodeURIComponent(s);
